// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d316d830","202":"d4f7faa9","274":"5aaff6ec","396":"37cb9d52","488":"de00eae7","612":"420d8514","717":"d9934b5e","794":"f230910b"}[chunkId] + ".js";
};